export default __webpack_public_path__ + "static/media/landing-1-circle-green.f34e7972.svg";